import { render } from "./MailboxIcon.vue?vue&type=template&id=a18a0a90"
import script from "./MailboxIcon.vue?vue&type=script&lang=js"
export * from "./MailboxIcon.vue?vue&type=script&lang=js"
script.render = render

export default script